import { CRM_BASE_URL, DAP_API, IAM_API } from "./config";

// My Project

// ===========================================================================================
// ================================== Landing ================================================
// ===========================================================================================

export const CURD_CUSTOMERS = `${CRM_BASE_URL}/v1/api/customer`;
export const CURD_CUSTOMERS_BY_ID = `${CRM_BASE_URL}/v1/api/customer/fetch-by-id`;
export const CURD_CUSTOMERS_BY_OWNER = `${CRM_BASE_URL}/v1/api/customer/fetch-by-owner`;
export const CRUD_CUSTOMERS_BY_OWNER = `${CRM_BASE_URL}/v1/api/customer/fetch-by-owner`;
export const CRUD_CUSTOMER_BUSINESS_DETAILS = `${CRM_BASE_URL}/v1/api/customer-business-detail`;
export const GET_CUSTOMER_BUSINESS_DETAILS_BY_CUSTOMER_ID = `${CRM_BASE_URL}/v1/api/customer-business-detail/byCustomerId`;

export const CURD_ACCOUNT = `${CRM_BASE_URL}/v1/api/customeraccounts`;
export const CURD_ACCOUNT_BY_ID = `${CRM_BASE_URL}/v1/api/customeraccounts/fetch-by-id`;
export const CURD_ACCOUNT_BY_OWNER = `${CRM_BASE_URL}/v1/api/customeraccounts/fetch-by-owner`;
export const CRUD_ACCOUNT_BY_OWNER = `${CRM_BASE_URL}/v1/api/customeraccounts/fetch-by-owner`;
export const CRUD_ACCOUNT_BILLING_DETAIL = `${CRM_BASE_URL}/v1/api/account-billing-detail`;
export const GET_ACCOUNT_BILLING_DETAIL_BY_ACCOUNT_ID = `${CRM_BASE_URL}/v1/api/account-billing-detail/byCustomerAccountId`;
export const CRUD_ACCOUNT_SOURCE = `${CRM_BASE_URL}/v1/api/account-source`;
export const CRUD_ACCOUNT_SOURCE_BY_ID = `${CRM_BASE_URL}/v1/api/account-source/fetch-by-id`;
export const GET_ACCOUNT_SOURCE_BY_ACCOUNT_ID = `${CRM_BASE_URL}/v1/api/account-source/byCustomerAccountId`;

export const CURD_ADDRESS = `${CRM_BASE_URL}/v1/api/address`;
export const CURD_ADDRESS_BY_ID = `${CRM_BASE_URL}/v1/api/address/fetch-by-id`;
export const CURD_ADDRESS_DETAILS_BY_ID = `${CRM_BASE_URL}/v1/api/address/detail/fetch-by-id`;

export const CURD_CONTACTS = `${CRM_BASE_URL}/v1/api/contacts`;
export const CURD_CONTACTS_BY_ID = `${CRM_BASE_URL}/v1/api/contacts/fetch-by-id`;
export const CURD_CONTACTS_BY_OWNER = `${CRM_BASE_URL}/v1/api/contacts/fetch-by-owner`;
export const CRUD_CONTACTS_BY_OWNER = `${CRM_BASE_URL}/v1/api/contacts/fetch-by-owner`;
export const CRUD_CONTACT_COMMUNICATION = `${CRM_BASE_URL}/v1/api/contact-communication`;
export const GET_CONTACT_COMMUNICATION_BY_CONTACT_ID = `${CRM_BASE_URL}/v1/api/contact-communication/byContactId`;
export const CRUD_CONTACT_SOURCE = `${CRM_BASE_URL}/v1/api/contact-source`;
export const GET_CONTACT_SOURCE_BY_CONTACT_ID = `${CRM_BASE_URL}/v1/api/contact-source/byContactId`;
export const CRUD_CONTACT_PRIVACY_CONSENT = `${CRM_BASE_URL}/v1/api/contact-privacy-consent`;

export const CRUD_PROSPECT = `${CRM_BASE_URL}/v1/api/prospect`;
export const CRUD_PROSPECT_ALERT = `${CRM_BASE_URL}/v1/api/prospect/delete-alert`;
export const CRUD_PROSPECT_BY_ID = `${CRM_BASE_URL}/v1/api/prospect/fetch-by-id`;
export const CRUD_PROSPECT_BY_OWNER = `${CRM_BASE_URL}/v1/api/prospect/fetch-by-owner`;
export const DOWNLOAD_PROSPECT = `${CRM_BASE_URL}/v1/api/excel-parser/batch-upload-prospects-template`;
export const UPLOAD_PROSPECT = `${CRM_BASE_URL}/v1/api/excel-parser/batch-upload-prospects`;

// Prospect Interest
export const CRUD_PROSPECT_INTEREST = `${CRM_BASE_URL}/v1/api/prospect-interest`;
export const GET_PROSPECT_INTEREST_BY_PROSPECT_ID = `${CRM_BASE_URL}/v1/api/prospect-interest/byProspectId`;

// Prospect Qualification
export const CRUD_PROSPECT_QUALIFICATION = `${CRM_BASE_URL}/v1/api/prospect-qualification`;
export const GET_PROSPECT_QUALIFICATION_BY_PROSPECT_ID = `${CRM_BASE_URL}/v1/api/prospect-qualification/byProspectId`;

// Prospect Source
export const CRUD_PROSPECT_SOURCE = `${CRM_BASE_URL}/v1/api/prospect-source`;
export const GET_PROSPECT_SOURCE_BY_PROSPECT_ID = `${CRM_BASE_URL}/v1/api/prospect-source/byProspectId`;

// Prospect Contact Communication
export const CRUD_PROSPECT_CONTACT_COMMUNICATION = `${CRM_BASE_URL}/v1/api/prospect-contact-communication`;
export const GET_PROSPECT_CONTACT_COMMUNICATION_BY_PROSPECT_CONTACT_ID = `${CRM_BASE_URL}/v1/api/prospect-contact-communication/byProspectContactId`;

// Prospect Contact Engagement
export const CRUD_PROSPECT_CONTACT_ENGAGEMENT = `${CRM_BASE_URL}/v1/api/prospect-contact-engagement`;
export const GET_PROSPECT_CONTACT_ENGAGEMENT_BY_PROSPECT_CONTACT_ID = `${CRM_BASE_URL}/v1/api/prospect-contact-engagement/byProspectContactId`;


export const CRUD_PROSPECT_CONTACT = `${CRM_BASE_URL}/v1/api/prospect-contact`;
export const CRUD_PROSPECT_CONTACT_PROSPECT_ID = `${CRM_BASE_URL}/v1/api/prospect-contact/byProspectId`;
export const CRUD_PROSPECT_CONTACT_BY_ID = `${CRM_BASE_URL}/v1/api/prospect-contact/fetch-by-id`;
export const DOWNLOAD_PROSPECT_CONTACT = `${CRM_BASE_URL}/v1/api/excel-parser/download-prospects-contact`;
export const UPLOAD_PROSPECT_CONTACT = `${CRM_BASE_URL}/v1/api/excel-parser/batch-upload-prospects-contact`;

// Prospect mapping
export const CRUD_PROSPECT_TAGGING = `${CRM_BASE_URL}/v1/api/prospect-tagging`;
export const CRUD_PROSPECT_TAGGING_ID = `${CRM_BASE_URL}/v1/api/prospect-tagging/byProspectId`;

// Prospect Conversion
export const CRUD_CONVERT_PROSPECT_TO_LEAD = `${CRM_BASE_URL}/v1/api/prospect-conversion/convert-to-lead`;
export const CRUD_CONVERT_PROSPECT_TO_INQUIRY = `${CRM_BASE_URL}/v1/api/prospect-conversion/convert-to-inquiry`;

export const CRUD_INQUIRY = `${CRM_BASE_URL}/v1/api/inquiry`;
export const CRUD_INQUIRY_ALERT = `${CRM_BASE_URL}/v1/api/inquiry/delete-alert`;
export const CRUD_INQUIRY_BY_ID = `${CRM_BASE_URL}/v1/api/inquiry/fetch-by-id`;
export const CRUD_INQUIRY_BY_OWNER = `${CRM_BASE_URL}/v1/api/inquiry/fetch-by-owner`;
export const DOWNLOAD_INQUIRY = `${CRM_BASE_URL}/v1/api/excel-parser/download-inquirys`;
export const UPLOAD_INQUIRY = `${CRM_BASE_URL}/v1/api/excel-parser/batch-upload-inquirys`;

// Inquiry mapping
export const CRUD_INQUIRY_TAGGING = `${CRM_BASE_URL}/v1/api/inquiry-tagging`;
export const CRUD_INQUIRY_TAGGING_ID = `${CRM_BASE_URL}/v1/api/inquiry-tagging/byInquiryId`;

// Inquiry Source
export const CRUD_INQUIRY_SOURCE = `${CRM_BASE_URL}/v1/api/inquiry-source`;
export const GET_INQUIRY_SOURCE_BY_INQUIRY_ID = `${CRM_BASE_URL}/v1/api/inquiry-source/byInquiryId`;

// Inquiry Qualification
export const CRUD_INQUIRY_QUALIFICATION = `${CRM_BASE_URL}/v1/api/inquiry-qualification`;
export const GET_INQUIRY_QUALIFICATION_BY_INQUIRY_ID = `${CRM_BASE_URL}/v1/api/inquiry-qualification/byInquiryId`;

// Inquiry Conversion
export const CRUD_CONVERT_INQUIRY_TO_LEAD = `${CRM_BASE_URL}/v1/api/inquiry-conversion/convert-to-lead`;
export const CRUD_CONVERT_INQUIRY_TO_PROSPECT = `${CRM_BASE_URL}/v1/api/inquiry-conversion/convert-to-prospect`;

export const CRUD_LEAD = `${CRM_BASE_URL}/v1/api/lead`;
export const CRUD_LEAD_ALERT = `${CRM_BASE_URL}/v1/api/lead/delete-alert`;
export const CRUD_LEAD_BY_ID = `${CRM_BASE_URL}/v1/api/lead/fetch-by-id`;
export const CRUD_LEAD_BY_OWNER = `${CRM_BASE_URL}/v1/api/lead/fetch-by-owner`;
export const DOWNLOAD_LEAD = `${CRM_BASE_URL}/v1/api/excel-parser/download-leads`;
export const UPLOAD_LEAD = `${CRM_BASE_URL}/v1/api/excel-parser/batch-upload-leads`;

// Lead mapping
export const CRUD_LEAD_TAGGING = `${CRM_BASE_URL}/v1/api/lead-tagging`;
export const CRUD_LEAD_TAGGING_ID = `${CRM_BASE_URL}/v1/api/lead-tagging/byLeadId`;

// Lead Qualification
export const CRUD_LEAD_QUALIFICATION = `${CRM_BASE_URL}/v1/api/lead-qualification`;
export const GET_LEAD_QUALIFICATION_BY_LEAD_ID = `${CRM_BASE_URL}/v1/api/lead-qualification/byLeadId`;

// Lead Source
export const CRUD_LEAD_SOURCE = `${CRM_BASE_URL}/v1/api/lead-source`;
export const GET_LEAD_SOURCE_BY_LEAD_ID = `${CRM_BASE_URL}/v1/api/lead-source/byLeadId`;

// Lead Conversion
export const CRUD_CONVERT_LEAD_TO_ACCOUNT = `${CRM_BASE_URL}/v1/api/lead-conversion/convert-to-account`;
export const CRUD_CONVERT_LEAD_TO_CONTACT = `${CRM_BASE_URL}/v1/api/lead-conversion/convert-to-contact`;
export const CRUD_CONVERT_LEAD_TO_OPPORTUNITY = `${CRM_BASE_URL}/v1/api/lead-conversion/convert-to-opportunity`;

export const CURD_CONTACT_TAGGING = `${CRM_BASE_URL}/v1/api/customer-account-contact`;
export const CURD_CONTACT_TAGGING_BY_ID = `${CRM_BASE_URL}/v1/api/customer-account-contact/fetch-by-id`;
export const CURD_CUSTOMER_TAGGING_BY_ID = `${CRM_BASE_URL}/v1/api/customer-account-contact/byCutomerId`;
export const CURD_ACCOUNT_TAGGING_BY_ID = `${CRM_BASE_URL}/v1/api/customer-account-contact/byCutomerAccountId`;

export const CURD_CONTACT_TAG = `${CRM_BASE_URL}/v1/api/customer-account-contact/tag`;

// ===========================================================================================
// ================================== CRM Config ================================================
// ===========================================================================================

export const CRUD_PRODUCT_CATEGORY = `${CRM_BASE_URL}/v1/api/product-category`;
export const CRUD_PRODUCT_TYPE = `${CRM_BASE_URL}/v1/api/product-type`;
export const CRUD_PRODUCT = `${CRM_BASE_URL}/v1/api/product`;
export const CRUD_PRODUCT_VARIANT = `${CRM_BASE_URL}/v1/api/product-variant`;
export const CRUD_PRODUCT_VARIANT_BY_ID = `${CRM_BASE_URL}/v1/api/product-variant/fetch-by-id`;
export const CRUD_PRODUCT_VARIANT_DETAIL_BY_ID = `${CRM_BASE_URL}/v1/api/product-variant/detailById`;

export const CRUD_PRODUCT_MODULE = `${CRM_BASE_URL}/v1/api/product-module`;
export const CRUD_PRODUCT_MODULE_BY_ID = `${CRM_BASE_URL}/v1/api/product-module/fetch-by-id`;

export const CRUD_PRODUCT_FEATURES = `${CRM_BASE_URL}/v1/api/product-features`;
export const CRUD_PRODUCT_FEATURES_BY_ID = `${CRM_BASE_URL}/v1/api/product-features/fetch-by-id`;

export const CRUD_SERVICES = `${CRM_BASE_URL}/v1/api/services`;

export const CRUD_MARKET_SEGMENT = `${CRM_BASE_URL}/v1/api/market-segment`;
export const CRUD_SEGMENT_TYPE = `${CRM_BASE_URL}/v1/api/segment-type`;

export const CRUD_PRIVACY_CONSENT = `${CRM_BASE_URL}/v1/api/privacy-consent`;

export const CRUD_IDEAL_CUSTOMER_PROFILE = `${CRM_BASE_URL}/v1/api/ideal-customer-profile`;
export const CRUD_MARKET = `${CRM_BASE_URL}/v1/api/market`;
export const CRUD_SUB_SEGMENT = `${CRM_BASE_URL}/v1/api/sub-segment`;

export const CRUD_SALES_TERRITORY = `${CRM_BASE_URL}/v1/api/sales-territory`;
export const CRUD_SALES_TERRITORY_BY_ID = `${CRM_BASE_URL}/v1/api/sales-territory/fetch-by-id`;
export const CRUD_SALES_REGION = `${CRM_BASE_URL}/v1/api/sales-region`;

export const CRUD_COMPETITOR = `${CRM_BASE_URL}/v1/api/competitor`;
export const CRUD_COMPETITOR_ANALYSIS = `${CRM_BASE_URL}/v1/api/competitor-analysis`;
export const CRUD_ADDRESS_TYPE = `${CRM_BASE_URL}/v1/api/address-type`;
// ===========================================================================================
// ================================== Platform Config ========================================
// ===========================================================================================

export const CURD_CUSTOMERS_TYPE = `${CRM_BASE_URL}/v1/api/customertype`;
export const CURD_CUSTOMERS_CURRENCY = `${CRM_BASE_URL}/v1/api/customerCurrency`;
export const CURD_CUSTOMERS_ACCOUNT_STATUS = `${CRM_BASE_URL}/v1/api/customer-status`;
export const CURD_CUSTOMERS_Category = `${CRM_BASE_URL}/v1/api/customer-category`;
export const CURD_INQUIRY_DISPOSITION = `${CRM_BASE_URL}/v1/api/inquiry-disposition`;
export const CURD_LEAD_QUALIFICATION_STATUS = `${CRM_BASE_URL}/v1/api/lead-qualification-status`;
export const CURD_CLOSURE_REASON = `${CRM_BASE_URL}/v1/api/closure-reason`;
export const CURD_CONSENT_STATUS = `${CRM_BASE_URL}/v1/api/consent-status`;
export const CURD_OPPORTUNITY_STAGE = `${CRM_BASE_URL}/v1/api/opportunity-stage`;
export const CRUD_CRM_STATUS = `${CRM_BASE_URL}/v1/api/crm-status`;
export const CRUD_STATUS_HISTORY = `${CRM_BASE_URL}/v1/api/status-history/fetch-by-id`;
export const CRUD_PERSON_TITLE = `${CRM_BASE_URL}/v1/api/person-title`;
export const CRUD_COMPETITOR_ROLE = `${CRM_BASE_URL}/v1/api/competitor-role`;
export const CRUD_COMPETITOR_THREAT_LEVEL = `${CRM_BASE_URL}/v1/api/competitor-threat-level`;

// ===========================================================================================
// ================================== Setup Config ========================================
// ===========================================================================================

export const CURD_ACCOUNT_MANAGER = `${CRM_BASE_URL}/v1/api/account-manager`;
export const CURD_CONTACT_METHOD = `${CRM_BASE_URL}/v1/api/contact-method`;
export const CURD_CONTACT_TYPE = `${CRM_BASE_URL}/v1/api/contact-type`;
export const CURD_CONTACT_ROLE = `${CRM_BASE_URL}/v1/api/contact-role`;
export const CURD_SALES_TEAM = `${CRM_BASE_URL}/v1/api/sales-team`;
export const CURD_RELATIONSHIP_STATUS = `${CRM_BASE_URL}/v1/api/relationship-status`;
export const CURD_CONSENT_SOURCE = `${CRM_BASE_URL}/v1/api/consent-source`;
export const CURD_INQUIRY_TYPE = `${CRM_BASE_URL}/v1/api/inquiry-type`;
export const CRUD_OPPORTUNITY_TYPE = `${CRM_BASE_URL}/v1/api/opportunity-type`;
export const CRUD_WIN_LOSS_REASON = `${CRM_BASE_URL}/v1/api/win-loss-reason`;
export const CRUD_BILLING_FREQUENCY = `${CRM_BASE_URL}/v1/api/billing-frequency`;
export const CRUD_DISQUALIFICATION_REASON = `${CRM_BASE_URL}/v1/api/disqualification-reason`;
export const CRUD_NURTURE_REASON = `${CRM_BASE_URL}/v1/api/nurture-reason`;
export const CRUD_SENIORITY_LEVEL = `${CRM_BASE_URL}/v1/api/seniority-level`;
export const CRUD_CONTACT_DEPARTMENT = `${CRM_BASE_URL}/v1/api/contact-department`;
export const CRUD_INFLUENCE_LEVEL = `${CRM_BASE_URL}/v1/api/influence-level`;
export const CRUD_COMPANY_SIZE = `${CRM_BASE_URL}/v1/api/company-size`;
export const CRUD_QUALIFICATION_READINESS = `${CRM_BASE_URL}/v1/api/qualification-readiness`;
export const CRUD_ENGAGEMENT_LEVEL = `${CRM_BASE_URL}/v1/api/engagement-level`;
export const CRUD_SOURCE = `${CRM_BASE_URL}/v1/api/source`;
export const CRUD_SALES_PRIORITY = `${CRM_BASE_URL}/v1/api/priority`;
export const CRUD_DECISION_AUTHORITY = `${CRM_BASE_URL}/v1/api/decision-authority`;
export const CRUD_PREFERRED_LANGUAGE = `${CRM_BASE_URL}/v1/api/preferred-language`;
export const CRUD_CONTACT_STATUS = `${CRM_BASE_URL}/v1/api/contact-status`;
export const CRUD_RESPONSE_STATUS = `${CRM_BASE_URL}/v1/api/response-status`;
export const CRUD_PROSPECT_TYPE = `${CRM_BASE_URL}/v1/api/prospect-type`;
export const CRUD_INTENT_LEVEL = `${CRM_BASE_URL}/v1/api/intent-level`;
export const CRUD_LEAD_TYPE = `${CRM_BASE_URL}/v1/api/lead-type`;
export const CRUD_LEAD_QUALIFICATION_MATURITY = `${CRM_BASE_URL}/v1/api/lead-qualification-maturity`;
export const CRUD_PURCHASE_TIMELINE = `${CRM_BASE_URL}/v1/api/purchase-timeline`;
export const CRUD_BUDGET_STATUS = `${CRM_BASE_URL}/v1/api/budget-status`;
export const CRUD_ACTIVITY_STATUS = `${CRM_BASE_URL}/v1/api/activity-status`;
export const CRUD_ACTIVITY_TYPE = `${CRM_BASE_URL}/v1/api/activity-type`;
export const CRUD_ACTIVITY_NAME = `${CRM_BASE_URL}/v1/api/activity-name`;
export const CRUD_ACTIVITY_NAME_BY_ID = `${CRM_BASE_URL}/v1/api/activity-name/fetch-by-id`;

export const CRUD_TIMELINE_STATUS = `${CRM_BASE_URL}/v1/api/timeline-status`;
export const CRUD_BUSINESS_NEED_STATUS = `${CRM_BASE_URL}/v1/api/business-need-status`;
export const CRUD_COMPETITOR_STATUS = `${CRM_BASE_URL}/v1/api/competitor-status`;
export const CRUD_COMPETITOR_TYPE = `${CRM_BASE_URL}/v1/api/competitor-type`;

export const CRUD_ACCOUNT_CATEGORY = `${CRM_BASE_URL}/v1/api/account-category`;
export const CRUD_ACCOUNT_TYPE = `${CRM_BASE_URL}/v1/api/account-type`;

export const CRUD_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity`;
export const CRUD_ACTIVITY_BY_ID = `${CRM_BASE_URL}/v1/api/activity/fetch-by-id`;
export const CRUD_ACTIVITY_DETAILS_BY_ID = `${CRM_BASE_URL}/v1/api/activity/fetch-by-id`;

export const CRUD_ATTACHMENT = `${CRM_BASE_URL}/v1/api/attachment`;
export const CRUD_ATTACHMENT_BY_ID = `${CRM_BASE_URL}/v1/api/attachment/fetch-by-id`;
export const CRUD_ATTACHMENT_VIEW = `${CRM_BASE_URL}/v1/api/attachment/view`;

export const CRUD_CAMPAIGN = `${CRM_BASE_URL}/v1/api/campaign`;
export const CRUD_CAMPAIGN_ALERT = `${CRM_BASE_URL}/v1/api/campaign/delete-alert`;
export const CRUD_CAMPAIGN_BY_ID = `${CRM_BASE_URL}/v1/api/campaign/fetch-by-id`;
export const CRUD_CAMPAIGN_BY_OWNER = `${CRM_BASE_URL}/v1/api/campaign/fetch-by-owner`;

// Campaign Team
export const CRUD_CAMPAIGN_TEAM = `${CRM_BASE_URL}/v1/api/campaign-team`;
export const GET_CAMPAIGN_TEAM_BY_CAMPAIGN_ID = `${CRM_BASE_URL}/v1/api/campaign-team/byCampaignId`;

// CRM Team
export const CRUD_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team`;

// Target Segment
export const CRUD_TARGET_SEGMENT = `${CRM_BASE_URL}/v1/api/target-segment`;
// Campaign Target Metric
export const CRUD_CAMPAIGN_TARGET_METRIC = `${CRM_BASE_URL}/v1/api/campaign-target-metric`;
export const GET_CAMPAIGN_TARGET_METRIC_BY_CAMPAIGN_ID = `${CRM_BASE_URL}/v1/api/campaign-target-metric/byCampaignId`;

// Campaign Channel
export const CRUD_CAMPAIGN_CHANNEL = `${CRM_BASE_URL}/v1/api/campaign-channel`;

export const CRUD_CAMPAIGN_CATEGORY = `${CRM_BASE_URL}/v1/api/campaign-category`;

export const CRUD_CAMPAIGN_TYPE = `${CRM_BASE_URL}/v1/api/campaign-type`;
export const CRUD_CAMPAIGN_TYPE_BY_ID = `${CRM_BASE_URL}/v1/api/campaign-type/fetch-by-id`;

export const CRUD_PAYMENT_TERM = `${CRM_BASE_URL}/v1/api/payment-term`;
export const CRUD_ASSIGNMENT_TYPE = `${CRM_BASE_URL}/v1/api/assignment-type`;
export const CRUD_PROCUREMENT_STATUS = `${CRM_BASE_URL}/v1/api/procurement-status`;
export const CRUD_ORDER_TYPE = `${CRM_BASE_URL}/v1/api/order-type`;

export const CRUD_CHANNEL_STATUS = `${CRM_BASE_URL}/v1/api/channel-status`;

// Opportunity
export const CRUD_OPPORTUNITY = `${CRM_BASE_URL}/v1/api/opportunity`;
export const CRUD_OPPORTUNITY_BY_OWNER = `${CRM_BASE_URL}/v1/api/opportunity/fetch-by-owner`;
export const CRUD_OPPORTUNITY_ALERT = `${CRM_BASE_URL}/v1/api/opportunity/delete-alert`;
export const CRUD_OPPORTUNITY_BY_ID = `${CRM_BASE_URL}/v1/api/opportunity/fetch-by-id`;

// Opportunity Detail
export const CRUD_OPPORTUNITY_DETAIL = `${CRM_BASE_URL}/v1/api/opportunity-detail`;
export const GET_OPPORTUNITY_DETAIL_BY_OPPORTUNITY_ID = `${CRM_BASE_URL}/v1/api/opportunity-detail/byOpportunityId`;

// Opportunity Qualification
export const CRUD_OPPORTUNITY_QUALIFICATION = `${CRM_BASE_URL}/v1/api/opportunity-qualification`;
export const GET_OPPORTUNITY_QUALIFICATION_BY_OPPORTUNITY_ID = `${CRM_BASE_URL}/v1/api/opportunity-qualification/byOpportunityId`;

// Opportunity Tagging
export const CRUD_OPPORTUNITY_TAGGING = `${CRM_BASE_URL}/v1/api/opportunity-tagging`;
export const GET_OPPORTUNITY_TAGGING_BY_OPPORTUNITY_ID = `${CRM_BASE_URL}/v1/api/opportunity-tagging/byOpportunityId`;

// Opportunity Source
export const CRUD_OPPORTUNITY_SOURCE = `${CRM_BASE_URL}/v1/api/opportunity-source`;
export const GET_OPPORTUNITY_SOURCE_BY_OPPORTUNITY_ID = `${CRM_BASE_URL}/v1/api/opportunity-source/byOpportunityId`;

// Opportunity Competitor Analysis
export const CRUD_OPPORTUNITY_COMPETITOR_ANALYSIS = `${CRM_BASE_URL}/v1/api/opportunity-competitor-analysis`;

// Opportunity Conversion
export const CRUD_CONVERT_OPPORTUNITY_TO_CONTRACT = `${CRM_BASE_URL}/v1/api/opportunity-conversion/convert-to-contract`;
export const CRUD_CONVERT_OPPORTUNITY_TO_ORDER = `${CRM_BASE_URL}/v1/api/opportunity-conversion/convert-to-order`;

export const CRUD_CONTRACT_STATUS = `${CRM_BASE_URL}/v1/api/contract-status`;
export const CRUD_CONTRACT_CATEGORY = `${CRM_BASE_URL}/v1/api/contract-category`;
export const CRUD_CONTRACT_TYPE = `${CRM_BASE_URL}/v1/api/contract-type`;
export const CRUD_CONTRACT = `${CRM_BASE_URL}/v1/api/contract`;
export const CRUD_CONTRACT_BY_ID = `${CRM_BASE_URL}/v1/api/contract/fetch-by-id`;
export const CRUD_CONTRACT_BY_OWNER = `${CRM_BASE_URL}/v1/api/contract/fetch-by-owner`;

export const CRUD_ORDER = `${CRM_BASE_URL}/v1/api/order`;
export const CRUD_ORDER_BY_ID = `${CRM_BASE_URL}/v1/api/order/fetch-by-id`;
export const CRUD_ORDER_BY_OWNER = `${CRM_BASE_URL}/v1/api/order/fetch-by-owner`;
export const CRUD_ORDER_ALERT = `${CRM_BASE_URL}/v1/api/order/delete-alert`;

// ================= Activity Routes =================
export const CRUD_CONTRACT_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/contract`;
export const GET_CONTRACT_ACTIVITY_BY_CONTRACT_ID = `${CRM_BASE_URL}/v1/api/activity/byContractId`;

export const CRUD_ACCOUNT_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/customer-account`;
export const GET_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID = `${CRM_BASE_URL}/v1/api/activity/byCustomerAccountId`;

export const CRUD_OPPORTUNITY_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/opportunity`;
export const GET_OPPORTUNITY_ACTIVITY_BY_OPPORTUNITY_ID = `${CRM_BASE_URL}/v1/api/activity/byOpportunityId`;

export const CRUD_CONTACT_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/contact`;
export const GET_CONTACT_ACTIVITY_BY_CONTACT_ID = `${CRM_BASE_URL}/v1/api/activity/byContactId`;

export const CRUD_LEAD_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/lead`;
export const GET_LEAD_ACTIVITY_BY_LEAD_ID = `${CRM_BASE_URL}/v1/api/activity/byLeadId`;

export const CRUD_CAMPAIGN_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/campaign`;
export const GET_CAMPAIGN_ACTIVITY_BY_CAMPAIGN_ID = `${CRM_BASE_URL}/v1/api/activity/byCampaignId`;

export const CRUD_INQUIRY_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/inquiry`;
export const GET_INQUIRY_ACTIVITY_BY_INQUIRY_ID = `${CRM_BASE_URL}/v1/api/activity/byInquiryId`;

export const CRUD_PROSPECT_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/prospect`;
export const GET_PROSPECT_ACTIVITY_BY_PROSPECT_ID = `${CRM_BASE_URL}/v1/api/activity/byProspectId`;

export const CRUD_CUSTOMER_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/customer`;
export const GET_CUSTOMER_ACTIVITY_BY_CUSTOMER_ID = `${CRM_BASE_URL}/v1/api/activity/byCustomerId`;

export const CRUD_ORDER_ACTIVITY = `${CRM_BASE_URL}/v1/api/activity/order`;
export const GET_ORDER_ACTIVITY_BY_ORDER_ID = `${CRM_BASE_URL}/v1/api/activity/byOrderId`;

// ================= CRM Team Routes =================
export const CRUD_CONTRACT_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/contract`;
export const GET_CONTRACT_CRM_TEAM_BY_CONTRACT_ID = `${CRM_BASE_URL}/v1/api/crm-team/byContractId`;

export const CRUD_ACCOUNT_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/customer-account`;
export const GET_ACCOUNT_CRM_TEAM_BY_ACCOUNT_ID = `${CRM_BASE_URL}/v1/api/crm-team/byCustomerAccountId`;

export const CRUD_OPPORTUNITY_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/opportunity`;
export const GET_OPPORTUNITY_CRM_TEAM_BY_OPPORTUNITY_ID = `${CRM_BASE_URL}/v1/api/crm-team/byOpportunityId`;

export const CRUD_CONTACT_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/contact`;
export const GET_CONTACT_CRM_TEAM_BY_CONTACT_ID = `${CRM_BASE_URL}/v1/api/crm-team/byContactId`;

export const CRUD_LEAD_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/lead`;
export const GET_LEAD_CRM_TEAM_BY_LEAD_ID = `${CRM_BASE_URL}/v1/api/crm-team/byLeadId`;

export const CRUD_CAMPAIGN_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/campaign`;
export const GET_CAMPAIGN_CRM_TEAM_BY_CAMPAIGN_ID = `${CRM_BASE_URL}/v1/api/crm-team/byCampaignId`;

export const CRUD_INQUIRY_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/inquiry`;
export const GET_INQUIRY_CRM_TEAM_BY_INQUIRY_ID = `${CRM_BASE_URL}/v1/api/crm-team/byInquiryId`;

export const CRUD_PROSPECT_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/prospect`;
export const GET_PROSPECT_CRM_TEAM_BY_PROSPECT_ID = `${CRM_BASE_URL}/v1/api/crm-team/byProspectId`;

export const CRUD_CUSTOMER_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/customer`;
export const GET_CUSTOMER_CRM_TEAM_BY_CUSTOMER_ID = `${CRM_BASE_URL}/v1/api/crm-team/byCustomerId`;

export const CRUD_ORDER_CRM_TEAM = `${CRM_BASE_URL}/v1/api/crm-team/order`;
export const GET_ORDER_CRM_TEAM_BY_ORDER_ID = `${CRM_BASE_URL}/v1/api/crm-team/byOrderId`;

// ===========================================================================================
// ================================== Dashboard ==============================================
// ===========================================================================================

export const GET_SALES_EXECUTIVE_DASHBOARD_SUMMARY = `${CRM_BASE_URL}/v1/api/dashboard/sales-executive/summary`;
export const GET_SALES_EXECUTIVE_OPPORTUNITY_VALUE_BY_STAGE = `${CRM_BASE_URL}/v1/api/dashboard/sales-executive/opportunity-value-by-stage`;
export const GET_SALES_EXECUTIVE_PRIORITY_WORK_QUEUE = `${CRM_BASE_URL}/v1/api/dashboard/sales-executive/priority-work-queue`;
export const GET_SALES_EXECUTIVE_LEAD_DISTRIBUTION = `${CRM_BASE_URL}/v1/api/dashboard/sales-executive/lead-distribution`;
export const GET_SALES_EXECUTIVE_LEAD_DISTRIBUTION_DETAILS = `${CRM_BASE_URL}/v1/api/dashboard/sales-executive/lead-distribution/details`;
export const GET_SALES_EXECUTIVE_ACTIVITIES_COMPLETED_THIS_WEEK = `${CRM_BASE_URL}/v1/api/dashboard/sales-executive/activities-completed-this-week`;

// ===========================================================================================
// ================================== Other Service ========================================
// ===========================================================================================

export const GET_ORG_USER = `${IAM_API}/v1/api/organization/customer-user/fetch-all-from-current-organization`;
export const GET_INDUSTRY_TYPE = `${DAP_API}/v1/api/piedap/industry`;
export const GET_DOMAIN_BY_INDUSTRY = `${DAP_API}/v1/api/piedap/domain_by_industry`;
export const GET_JOB_TITLE = `${DAP_API}/v1/api/piedap/job_title`;
